export function gmtOffset() {
  const date = new Date();
  const winter = new Date(date.getFullYear(), 0, 1);
  const summer = new Date(date.getFullYear(), 6, 1);
  const winterOffset = -winter.getTimezoneOffset();
  const summerOffset = -summer.getTimezoneOffset();

  return (winterOffset < summerOffset) ? winterOffset : summerOffset;
}
